<div id="standing-authorizations-table">
  <span class="section-title" id="title">Standing authorizations
    <mm-tooltip data-testid="standingauth" [position]="'right'" [containsLink]="false">
      <tooltip-content>
        <div data-testid="tooltipText">This is Schwab’s record of the bank or account information that authorizes an
          advisor to move a client's money on their behalf.</div>
      </tooltip-content>
      <tooltip-trigger-element>
        <sdps-icon color="active" type="functional" name="info" size="small"></sdps-icon>
      </tooltip-trigger-element>
    </mm-tooltip>
  </span>
  <sdps-tabs sdps-id="standing-auth-table-tabs" id="standing-auth-table-tabs">
    <sdps-tab-bar slot="bar" id="transaction-type-bar">
      <sdps-tab-button class="preset-filter-tab" sdps-id="all" [selected]="currentTab === 'All'">All</sdps-tab-button>
      <sdps-tab-button class="preset-filter-tab" sdps-id="ach" [selected]="currentTab === 'ACH transfers'">ACH transfers</sdps-tab-button>
      <sdps-tab-button class="preset-filter-tab" sdps-id="internal-transfers" [selected]="currentTab === 'Internal transfers'">Internal transfers</sdps-tab-button>
      <sdps-tab-button class="preset-filter-tab" sdps-id="wires" [selected]="currentTab === 'Wires'">Wires</sdps-tab-button>
      <sdps-tab-button class="preset-filter-tab" sdps-id="checks" [selected]="currentTab === 'Checks'">Checks</sdps-tab-button>
      <sdps-button *ngIf="createTransactionPage && createStandingAuthEnabled" id="create-standing-auth-button"
        data-testid="create-standing-auth-button" size="small" class="sdps-m-left_medium" variation="secondary"
        (click)="onCreateStandingAuthClick()">Create standing
        authorization</sdps-button>
    </sdps-tab-bar>
  </sdps-tabs>
  <mm-table [columnDefs]="columnDefs" [defaultColumnDefs]="defaultColumnDefs" [rowData]="rowData$ | async" [presetFilters]="filterModel"
    [noExportCol]="noExportCol" [fileName]="fileName" [tableName]="'standing authorizations'"
    [componentState$]="standingAuthTableState$" [showFilterCount]="true" [showTableOptions]="true"
    (gridReadyEvent)="updateGridReady($event)" [showFloatingFilter]="true" [headerHeight]="25" [rowHeight]="25"></mm-table>
  <delete-standing-auth-modal [showModal$]="deleteLinkClickedAsObservable$" [currentTransaction$]="currentSelectedTransactionAsObservable$"></delete-standing-auth-modal>
</div>
